<script>
import { computed, ref } from 'vue'
import { useJackpotStore } from '@/stores/jackpot.js'
import { useAuthStore } from '@/stores/auth.js'
import router from '@/router/index.js'
import $ from 'jquery'
import emitter from '@/services/eventbus.js'
import { useIpAddressStore } from '@/stores/ipAddress.js'
import { useUTMsStore } from '@/stores/utms.js'
import { getChannelId } from '@/utils/functions.js'
import { getDeviceInfo } from '@/utils/deviceType.js'
import { useBalanceStore } from '@/stores/balance.js'
import { encryptData2 } from '@/utils/functions.js'
import { useJackpotTokensStore } from '@/stores/jackpotToken.js'

export default {
  name: 'JackpotFooter',
  setup() {
    const jackpotStore = useJackpotStore()
    const ipAddressStore = useIpAddressStore()
    const tokenStore     = useJackpotTokensStore()
    const isBetDisabled = ref(false)
    const showSuccessModal = ref(false)
    const betId            = ref(null)

    const total = computed(() => jackpotStore.jSlip?.total || 0)
    const jackpot = {
      prize: jackpotStore.jackpotData ? jackpotStore.jackpotData.prize : 0,
      stake: jackpotStore.jackpotData ? jackpotStore.jackpotData.stake : 0,
      start_time: jackpotStore.jackpotData ? jackpotStore.jackpotData.start : '',
      end_time: jackpotStore.jackpotData ? jackpotStore.jackpotData.end : '',
      number_of_games: jackpotStore.jackpotData ? jackpotStore.jackpotData.number_of_games : 0
    }

    const hasGames = computed(() => {
      return jackpotStore.jackpotData && jackpotStore.jackpotData.number_of_games > 0
    })

    const MB8 = computed(() => tokenStore.MB8)

    const placebet = async () => {
      if (isBetDisabled.value) return

      isBetDisabled.value = true

      const authStore = useAuthStore()
      if (!authStore.user) {
        await router.push({ name: 'login' })
        emitter.emit('setInfo', 'Login to continue')
        isBetDisabled.value = false
        return
      }

      if (MB8.value <= 0) {
        emitter.emit(
          'setError',
          'You do not have a ticket to place this bet. Please deposit, then place a bet with at least 3 games at minimum 1.5 odds to play.'
        )
        isBetDisabled.value = false
        return
      }

      let bets = []
      $.each(jackpotStore.jSlip.picks, function (index, pick) {
        bets.push({
          match_number: pick.match_number,
          match_id: pick.match_id,
          market_id: pick.market_id,
          outcome_id: pick.outcome_id,
          specifier: pick.specifier,
          producer_id: 3
        })
      })

      const ipAddress = ipAddressStore.ipAddress
      const UTMs = useUTMsStore()
      const referrer = localStorage.getItem('referrer')
      const userAgent = navigator.userAgent
      const channel_id = getChannelId(userAgent)
      // const deviceInfo = getDeviceInfo();

      // Construct the payload
      const payload = {
        bet_type: 1,
        bets: bets,
        booking_code: '',
        campaign: '',
        ip_address: ipAddress,
        medium: '',
        source: 1,
        stake: parseInt(jackpotStore.jackpotData.stake),
        stake_type: '',
        utm_source: String(UTMs.utmSource),
        useragent: JSON.stringify(navigator.userAgent),
        browser: String(UTMs.utmBrowser),
        utm_medium: String(UTMs.utmMedium),
        utm_campaign: String(UTMs.utmCampaign),
        utm_id: String(UTMs.utmId),
        utm_referral: String(UTMs.utmReferral),
        utm_term: String(UTMs.utmTerm),
        utm_content: String(UTMs.utmContent),
        referrer: String(referrer || UTMs.referrer),
        channel_id: channel_id,
        xp: Math.floor(Date.now() / 1000),
        gclid: UTMs.gclid
        // device_info: deviceInfo.model,
      }

      // Validate bet count according to jackpot category
      if (jackpotStore.jackpotData.jackpot_category_id === 6) {
        if (payload.bets.length !== 13) {
          emitter.emit('error', 'Please select exactly 13 games for Weekly Jackpot.')
          isBetDisabled.value = false
          return
        }
      } else if (jackpotStore.jackpotData.jackpot_category_id === 4) {
        // if (payload.bets.length !== 10) {
        //   emitter.emit('error', 'Please select exactly 10 games for Daily Jackpot.')
        //   isBetDisabled.value = false
        //   return
        // }
        if (payload.bets.length !== 8) {
          emitter.emit('error', 'Please select exactly 8 games for MB8 Jackpot.')
          isBetDisabled.value = false
          return
        }
      }

      try {
        // console.log("JP Payload: " + JSON.stringify(payload))
        const encryptedPayload = encryptData2(payload)
        const requestData = { data: encryptedPayload }

        const response = await jackpotStore.placeBet(requestData)
        betId.value = response.bet_id
        emitter.emit('setSuccess', response.data)
        const balanceStoreInstance = useBalanceStore()
        balanceStoreInstance.balanceFetched = false
        await balanceStoreInstance.fetchBalance()
        await tokenStore.fetchMB8()

        showSuccessModal.value = true
      } catch (error) {
        emitter.emit('setError', 'Failed to place bet. Please try again.')
      } finally {
        setTimeout(() => {
          isBetDisabled.value = false
        }, 10000)
      }
    }

    const goHome = () => {
      showSuccessModal.value = false
      jackpotStore.clearJackpotBetSlip()
      window.location.href= '/'
    }

    const closeSuccessModal = () => {
      showSuccessModal.value = false
      jackpotStore.clearJackpotBetSlip()
    }

    const clearBetSlip = () => {
      jackpotStore.clearJackpotBetSlip()
    }
    const autoPick = () => {
      jackpotStore.autoPick()
    }

    return {
      total,
      jackpot,
      placebet,
      clearBetSlip,
      autoPick,
      hasGames,
      isBetDisabled,
      showSuccessModal,
      closeSuccessModal,
      goHome,
      tokenStore,
      betId
    }
  }
}
</script>

<template>
  <div v-if="hasGames" class="footer-navigation">
    <div :class="['jbetslip-counter-wrap', { 'd-none': total <= 0 }]">
      <div class="container">
        <div class="row">
          <div class="betslip-counter">
            <span class="games-number">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="placebet-wrapper position-static">
      <div class="container pt-2">
        <div class="row align-items-center gx-0">
          <div class="col-4">
            <div class="autopick-betslip">
              <div class="text-center" @click="autoPick">
                <span class="icon"><i class="bi bi-shuffle"></i></span>
                <h6>Auto Pick</h6>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="placebet-btn">
              <div class="view-betslip">
                <button class="btn btn-success w-100" :disabled="isBetDisabled" @click="placebet">
                  Place Bet
                </button>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="autopick-betslip">
              <div class="text-center" @click="clearBetSlip">
                <span class="icon"><i class="bi bi-trash"></i></span>
                <h6>Clear Bet</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Success Modal -->
  <div
    class="modal-backdrop fade show"
    v-if="showSuccessModal"
  ></div>
  <div
    class="modal fade show"
    tabindex="-1"
    style="display: block;"
    v-if="showSuccessModal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Bet Placed</h5>
          <button type="button" class="btn-close" @click="closeSuccessModal"></button>
        </div>
        <div class="modal-body">
          <p>Congratulations!</p>
          <p>Your jackpot bet was placed successfully!</p>
          <p><strong>Bet ID:</strong> {{ betId }}</p>
          <p><strong>Tickets left:</strong> {{ tokenStore.MB8 }}</p>
        </div>
        <div class="modal-footer">
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="goHome">
              Go Home
            </button>
            <button type="button" class="btn btn-primary" @click="closeSuccessModal">
              Place Another Bet
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.jbetslip-counter-wrap {
  width: 100%;
  padding: 3px;
  background-color: #9ce800;
  color: #283441;
}

.autopick-betslip a h6 {
  font-size: 12px;
  font-weight: 800;
}

.modal-backdrop.show {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal.show {
  display: block;
}

.modal-dialog {
  max-width: 400px;
  margin: 2rem auto;
}

.modal-content {
  max-width: 450px;
  width: 90%;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.2);
  overflow: hidden;
  margin: auto;
}

.modal-header,
.modal-body,
.modal-footer {
  color: #283441 !important;
}

modal-title {
  color: #FFFFFF;
}

.modal-header {
  border-bottom: none;
  background-color: var(--color-fg);
  padding: 1rem 1.5rem;
}
.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-bg);
}
.btn-close {
  font-size: .9rem;
  background-color: yellow;
  opacity: 0.6;
}
.btn-close:hover {
  opacity: 1;
}

.modal-body {
  padding: 1.5rem;
  background-color: var(--color-bg);
  color: var(--color-fg);
  text-align: center;
}
.modal-body p {
  margin-bottom: 1rem;
}

.modal-footer {
  border-top: none;
  background-color: var(--color-fg);
  padding: 1rem 1.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
}

.btn-outline-secondary {
  border-color: #8faf37;
  color: #283441;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
}
.btn-outline-secondary:hover {
  background-color: #f0f0f0;
}

.btn-primary {
  background-color: #8faf37;
  border-color: #8faf37;
  color: #283441;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
  transition: background-color 0.2s;
}
.btn-primary:hover {
  background-color: #8faf37;
}

@media (min-width: 576px) {
  .modal-footer {
    flex-direction: row;
    gap: 1rem;
  }
}

@media (max-width: 360px) {
  .modal-title {
    font-size: 1.1rem;
  }
  .modal-body {
    padding: 1rem;
  }
  .btn-primary,
  .btn-outline-secondary {
    font-size: 0.9rem;
    padding: 0.4rem 0.75rem;
  }
}
</style>
